/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useState, useEffect } from 'react';
import defer from 'hs-promise-utils/defer';
export const useSettings = fetchSiteSettings => {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    const deferredRequest = defer();
    fetchSiteSettings().then(deferredRequest.resolve);
    deferredRequest.promise.then(setSettings).catch(console.warn);
    return () => {
      deferredRequest.reject('[rich-text-lib][personalization][fetchSettings] component unmounting abort state update');
    };
  }, [fetchSiteSettings]);
  return settings;
};